<div class="content" id="otb-layout" *ngIf="showContent && !showloading">
  <div class="signup-wrapper">
    <div class="signup-box">
      <div class="signup-container">
        <!-- Content Section -->
        <div class="signup-details" *ngIf="signUpData">
          <h4 [innerHTML]="signUpData.content.title"></h4>

          <div class="list-with-icon" *ngFor="let section of signUpData.content.sections">
            <img [src]="section.icon" alt="Icon" class="list-main-icon" />
            <ul class="no-list-style">
              <li *ngFor="let item of section.items" [innerHTML]="item"></li>
            </ul>
            <div class="sections-details"></div>
          </div>

          <p *ngFor="let text of signUpData.content.footerText">{{ text }}</p>
        </div>

        <!-- Form Section -->
        <div class="signup-form" *ngIf="signUpData">
          <div class="logo">
            <img [src]="signUpData.forms.logo" alt="Bahamas Logo" class="logo-img">
            <!-- <div class="brand-text" *ngIf="signUpData.forms.brandTitle || signUpData.forms.brandSubtitle">
              <div class="brand-title" *ngIf="signUpData.forms.brandTitle" [innerHTML]="signUpData.forms.brandTitle">
              </div>
              <div class="brand-subtitle" *ngIf="signUpData.forms.brandSubtitle"
                [innerHTML]="signUpData.forms.brandSubtitle"></div>
            </div> -->
          </div>
          <h3>{{ signUpData.forms.title }}</h3>
          <p *ngIf="signUpData.forms.subtitle && (typeof signUpData.forms.subtitle === 'string')"
            [innerHTML]="signUpData.forms.subtitle"></p>
          <p *ngIf="signUpData.forms.subtitle && (typeof signUpData.forms.subtitle !== 'string')">
            <span [innerHTML]="signUpData.forms.subtitle.text"></span>
            <a *ngIf="signUpData.forms.subtitle.link" [href]="signUpData.forms.subtitle.link.href"
              [attr.target]="signUpData.forms.subtitle.link.target" [attr.rel]="signUpData.forms.subtitle.link.rel">
              {{ signUpData.forms.subtitle.link.label }}
            </a>
          </p>


          <form (ngSubmit)="onSubmit()">
            <!-- User type selector - COMMENTED OUT -->
            <!-- <div class="plain-input-wrapper usertype-wrapper" style="display:flex;align-items:center;gap:8px;">
              <label class="field-label" style="margin:0;">Login as:</label>
              <div class="input-with-toggle" style="flex:1;">
                <select [(ngModel)]="formValues['userType']" name="userType" [ngModelOptions]="{standalone: true}"
                  (change)="onUserTypeChange($event)"
                  [disabled]="formValues['tinNumber'] || formValues['userId']  || currentStep > 0">
                  <option *ngFor="let ut of userTypes" [value]="ut">{{ ut | titlecase }}</option>
                </select>
              </div>
            </div> -->
            <ng-container *ngIf="signUpData?.forms && signUpData.forms[activeForm]">
              <div *ngFor="let field of signUpData.forms[activeForm].fields; let i = index">
                <!-- NOTE: Show userId and password fields together initially (not step-based) -->
                <!-- Hide password field when activation instructions are visible to avoid duplicate UI -->
                <div
                  *ngIf="showField(field, i) && (((activeForm === 'signupForm') && (field.key === 'userId' || field.key === 'password' || field.key === 'rememberPassword')) || showField(field, i)) && !(field.key === 'password' && (activationSent || (activeForm === 'forgotPasswordForm' && forgotPasswordInstructionsSent)))">
                  <div class="plain-input-wrapper" [ngClass]="{
                      'vis-center': field.key === 'newPassword' || field.key === 'confirmPassword',
                      'input-error': (field.key === 'registeredEmail' && emailFieldErrors[field.key]) || (showError && field.required && (!formValues[field.key] || formValues[field.key] === '')) || (field.key === 'userId' && userIdNotFound)
                    }">
                    <ng-container
                      *ngIf="field.type !== 'checkbox' && field.type !== 'radio' && field.type !== 'captcha'">
                      <label class="field-label">{{ field.label }}<span class="required-asterisk"
                          *ngIf="field.required">*</span></label>
                      <div class="input-with-toggle">
                        <input [id]="'signup-field-' + i" [attr.data-key]="field.key"
                          [attr.type]="(field.type === 'password' ? (field.hide ? 'password' : 'text') : field.type)"
                          [(ngModel)]="formValues[field.key]" (ngModelChange)="onFieldChange(field.key)"
                          [placeholder]="field.placeholder" [attr.required]="field.required ? true : null"
                          (keydown.enter)="handleEnterOnField($event)"
                          [disabled]="(field.key !== 'password' && field.key !== 'rememberPassword' && (i < currentStep || (field.key === 'userId' && currentStep > 0))) || (field.key === 'registeredEmail' && (forgotPasswordInstructionsSent || activationSent)) || (field.key === 'userId' && (isFirstTimeUser || forgotPasswordInstructionsSent))"
                          [readonly]="field.key === 'userId' && (isFirstTimeUser || forgotPasswordInstructionsSent)"
                          [ngModelOptions]="{standalone: true}" autocomplete="off" autocorrect="off"
                          autocapitalize="off" spellcheck="false"
                          (paste)="(field.key === 'userId' || field.key === 'password') ? null : preventPaste($event)"
                          (copy)="(field.key === 'userId' || field.key === 'password') ? null : preventCopy($event)"
                          (cut)="(field.key === 'userId' || field.key === 'password') ? null : preventCut($event)"
                          (contextmenu)="(field.key === 'userId' || field.key === 'password') ? null : preventContext($event)"
                          (drop)="(field.key === 'userId' || field.key === 'password') ? null : preventDrop($event)"
                          [ngClass]="{'input-error': ( (field.key === 'newPassword' && (!formValues['newPassword'] || formValues['newPassword'] === '')) || (field.key === 'confirmPassword' && (!formValues['confirmPassword'] || formValues['confirmPassword'] === '')) ) }" />

                        <button *ngIf="field.type === 'password'" type="button" class="visibility-toggle"
                          (click)="toggleVisibility(i)" aria-label="Toggle password visibility">
                          <mat-icon>{{ field.hide ? 'visibility_off' : 'visibility'
                            }}</mat-icon>
                        </button>
                      </div>


                    </ng-container>

                    <!-- Radio type rendering (for MFA method selection) - rendered outside the input-only container so it can show -->
                    <ng-container *ngIf="field.type === 'radio'">
                      <label class="field-label">{{ field.label }}<span class="required-asterisk"
                          *ngIf="field.required">*</span></label>
                      <div class="radio-group">
                        <label *ngFor="let opt of field.options">
                          <input id="mfa-method-{{opt.value}}" type="radio" name="{{field.key}}" [value]="opt.value"
                            [(ngModel)]="formValues[field.key]" [ngModelOptions]="{standalone: true}"
                            (change)="onFieldChange(field.key)" [disabled]="mfaOtpSent" />
                          {{ opt.label }}
                        </label>
                      </div>
                      <div *ngIf="mfaOtpError && !formValues['mfaMethod']" class="field-error">{{
                        mfaOtpError }}</div>
                    </ng-container>

                    <div *ngIf="field.key === 'registeredEmail' && emailFieldErrors[field.key]" class="field-error">{{
                      emailFieldErrors[field.key] }}</div>
                    <!-- activation UI is now rendered once (see below) -->

                    <div *ngIf="field.key === 'password' && showError && field.required && !formValues[field.key]"
                      class="field-error">{{ field.errorLabel || field.label }} is required</div>


                    <ng-container *ngIf="field.key === 'password'">
                      <div class="password-actions-row">
                        <!-- <div class="remember-row">
                          <input type="checkbox" [(ngModel)]="formValues['rememberPassword']"
                            [ngModelOptions]="{standalone: true}" id="signup-remember-{{i}}" />
                          <label for="signup-remember-{{i}}" class="remember-label">Remember
                            me</label>
                        </div> -->
                        <div *ngIf="field.key === 'password' && showForgotLink" class="forgot-password-inline">
                          <a (click)="forgotPassword()">Forgot password?</a>
                        </div>
                      </div>
                    </ng-container>


                    <ng-container *ngIf="field.type === 'checkbox' && field.key !== 'rememberPassword'">
                      <div class="checkbox-inline">
                        <input type="checkbox" [(ngModel)]="formValues[field.key]" [ngModelOptions]="{standalone: true}"
                          id="signup-checkbox-{{i}}" />
                        <label for="signup-checkbox-{{i}}" class="checkbox-label">{{ field.label
                          }}</label>
                      </div>
                    </ng-container>
                  </div>

                  <div *ngIf="field.key !== 'password' && showError && field.required && !formValues[field.key]"
                    class="field-error">
                    {{ field.errorLabel || field.label }} is required
                  </div>


                  <!-- <div *ngIf="field.key === 'password' && showForgotLink" class="forgot-password">
                    <a (click)="forgotPassword()">Forgot password?</a>
                  </div> -->



                </div>
              </div>
            </ng-container>

            <div *ngIf="userIdNotFound" class="first-time-login-banner">
              <span>{{ userIdNotFound }}</span>
            </div>


            <!-- Single activation/instructions area (rendered once) -->
            <div *ngIf="activationSent || forgotPasswordInstructionsSent" class="activation-area">
              <!-- <div class="activation-message">{{ activationMessage }}</div> -->
              <div class="first-time-login-banner">
                <mat-icon class="banner-icon">mail_outline</mat-icon>
                <span>{{ activationMessage }}</span>
              </div>
              <div class="activation-controls activation-inline">
                <button type="button" class="cancel-btn" (click)="goBack()">
                  <span class="button-content">
                    <mat-icon>arrow_back</mat-icon>
                    <span class="button-text">Back</span>
                  </span>
                </button>
                <button type="button" class="submit-btn" (click)="resendActivation()"
                  [disabled]="isButtonDisabled('resendActivation')"
                  [attr.aria-disabled]="isButtonDisabled('resendActivation')">
                  <span class="button-content">
                    <span class="button-text">{{ getButtonText('resendActivation') }}</span>
                  </span>
                </button>
              </div>
              <!-- <div class="follow-actions">
                <a *ngIf="activationSent || forgotPasswordInstructionsSent" class="proceed-link"
                  (click)="goToUpdatePassword()">Proceed to update password</a>
              </div> -->
            </div>

            <!-- MFA-specific area: show conditional contact field and OTP entry -->
            <div *ngIf="activeForm === 'mfaLoginForm'" class="mfa-area">
              <!-- First-time login message banner -->
              <!-- <div *ngIf="firstTimeLoginMessage" class="first-time-login-banner">
                <mat-icon class="banner-icon">mail_outline</mat-icon>
                <span>{{ firstTimeLoginMessage }}</span>
              </div> -->

              <div *ngIf="formValues['mfaMethod'] === 'mobile'" class="plain-input-wrapper">
                <label class="field-label">{{ getFieldLabelFromJson('mfaMobile', 'Mobile Number')
                  }}<span class="required-asterisk" *ngIf="getActiveFormField('mfaMobile')?.required">*</span></label>
                <div class="input-with-toggle">
                  <input id="mfa-mobile-field" [attr.type]="getActiveFormField('mfaMobile')?.type || 'tel'"
                    [ngModel]="mfaPreloaded ? getMfaMobileDisplay() : formValues['mfaMobile']"
                    (ngModelChange)="onMfaMobileInputChange($event)" [ngModelOptions]="{standalone: true}"
                    autocomplete="off" [placeholder]="getFieldPlaceholderFromJson('mfaMobile', '+1 242 000 0000')"
                    [attr.required]="getActiveFormField('mfaMobile')?.required ? true : null"
                    [ngClass]="{'input-error': mfaOtpError && formValues['mfaMethod'] === 'mobile'}"
                    [disabled]="mfaOtpSent || mfaPreloaded" [readonly]="mfaPreloaded" />

                </div>
                <div *ngIf="mfaOtpError && formValues['mfaMethod'] === 'mobile' && !mfaOtpSent" class="field-error">{{
                  mfaOtpError }}</div>
              </div>

              <div *ngIf="formValues['mfaMethod'] === 'email'" class="plain-input-wrapper">
                <label class="field-label">{{ getFieldLabelFromJson('mfaEmail', 'Email Address') }}<span
                    class="required-asterisk" *ngIf="getActiveFormField('mfaEmail')?.required">*</span></label>
                <div class="input-with-toggle">
                  <input id="mfa-email-field" [attr.type]="getActiveFormField('mfaEmail')?.type || 'email'"
                    [ngModel]="mfaPreloaded ? getMfaEmailDisplay() : formValues['mfaEmail']"
                    (ngModelChange)="onMfaEmailInputChange($event)" [ngModelOptions]="{standalone: true}"
                    autocomplete="off" [placeholder]="getFieldPlaceholderFromJson('mfaEmail', 'name@example.com')"
                    [attr.required]="getActiveFormField('mfaEmail')?.required ? true : null"
                    [ngClass]="{'input-error': mfaOtpError && formValues['mfaMethod'] === 'email'}"
                    [disabled]="mfaOtpSent || mfaPreloaded" [readonly]="mfaPreloaded" />

                </div>
                <div *ngIf="mfaOtpError && formValues['mfaMethod'] === 'email' && !mfaOtpSent" class="field-error">{{
                  mfaOtpError }}</div>
              </div>

              <div *ngIf="mfaOtpSent" class="otp-section" [ngClass]="{'input-error': mfaOtpError}">
                <label class="field-label">{{ getFieldLabelFromJson('mfaOtp', 'Enter OTP') }}<span
                    class="required-asterisk" *ngIf="getActiveFormField('mfaOtp')?.required">*</span></label>
                <div class="otp-input-row otp-input-boxes" (paste)="preventPaste($event)">
                  <ng-container *ngFor="let _ of [].constructor(6); let idx = index">
                    <div class="otp-input-box">
                      <input type="text" maxlength="1" [attr.data-idx]="idx" (input)="onMfaInlineOtpInput($event, idx)"
                        (keydown)="onMfaInlineOtpKeydown($event, idx)" />
                    </div>
                  </ng-container>
                </div>
                <div *ngIf="mfaOtpError" class="field-error">{{ mfaOtpError }}</div>

                <div class="captcha-row" *ngIf="activeFormHasCaptcha()">
                  <label class="captcha-label">{{ getFieldLabelFromJson('captcha', 'Captcha
                    Verification') }}<span class="required-asterisk"
                      *ngIf="getActiveFormField('captcha')?.required">*</span></label>
                  <div class="captcha-box">
                    <div class="captcha-canvas-wrap">
                      <canvas id="captchaCanvas" width="140" height="48"></canvas>
                    </div>
                    <button type="button" class="captcha-refresh" (click)="refreshCaptcha()"
                      aria-label="Refresh captcha">
                      <mat-icon>refresh</mat-icon>
                    </button>
                    <input id="signup-captcha-input" class="captcha-input-field" matInput [attr.type]="'text'"
                      [placeholder]="getFieldPlaceholderFromJson('captcha', 'Enter CAPTCHA')"
                      [formControl]="captchaControl" (input)="verifyCaptcha()" />
                  </div>
                  <div *ngIf="captchaError" class="field-error">{{ captchaError }}</div>
                </div>
              </div>
            </div>

            <div class="button-group" *ngIf="!activationSent">
              <!-- Special-case MFA form buttons -->
              <ng-container *ngIf="activeForm === 'mfaLoginForm'">
                <div *ngIf="!mfaOtpSent" class="mfa-initial-actions">
                  <button type="button" [class]="getButtonClass('goBack','mfaLoginForm') || 'cancel-btn'"
                    (click)="cancelMfaInitial()">
                    <span class="button-content">
                      <mat-icon *ngIf="getButtonIcon('goBack','mfaLoginForm')">{{
                        getButtonIcon('goBack','mfaLoginForm')
                        }}</mat-icon>
                      <span class="button-text">{{ getButtonText('goBack') }}</span>
                    </span>
                  </button>
                  <button type="button" [class]="getButtonClass('sendMfaOtp','mfaLoginForm') || 'submit-btn'"
                    (click)="sendMfaOtp()" [disabled]="isButtonDisabled('sendMfaOtp')"
                    [attr.aria-disabled]="isButtonDisabled('sendMfaOtp')">
                    <span class="button-content reverse-order">
                      <span class="button-text">{{ getButtonText('sendMfaOtp') }}</span>
                      <mat-icon *ngIf="getButtonIcon('sendMfaOtp','mfaLoginForm')">{{
                        getButtonIcon('sendMfaOtp','mfaLoginForm') }}</mat-icon>
                    </span>
                  </button>
                </div>
                <div *ngIf="mfaOtpSent" class="mfa-verify-actions">
                  <button type="button" class="cancel-btn" (click)="cancelMfa()">
                    <span class="button-content">
                      <mat-icon *ngIf="getButtonIcon('goBack','mfaLoginForm')">{{
                        getButtonIcon('goBack','mfaLoginForm')
                        }}</mat-icon>
                      <span class="button-text">{{ getButtonText('goBack') }}</span>
                    </span>
                  </button>
                  <div class="action-row">
                    <button type="button" [class]="getButtonClass('verifyMfaOtp','mfaLoginForm') || 'submit-btn'"
                      (click)="verifyMfaOtp()">
                      <span class="button-content reverse-order">
                        <span class="button-text">{{ getButtonText('verifyMfaOtp') }}</span>
                        <mat-icon *ngIf="getButtonIcon('verifyMfaOtp','mfaLoginForm')">{{
                          getButtonIcon('verifyMfaOtp','mfaLoginForm') }}</mat-icon>
                      </span>
                    </button>
                    <button type="button" [class]="getButtonClass('resendMfa','mfaLoginForm') || 'submit-btn'"
                      (click)="resendMfa()" [disabled]="isButtonDisabled('resendMfa')"
                      [attr.aria-disabled]="isButtonDisabled('resendMfa')">
                      <span class="button-content reverse-order">
                        <span class="button-text">{{ getButtonText('resendMfa') }}</span>
                        <mat-icon *ngIf="getButtonIcon('resendMfa','mfaLoginForm')">{{
                          getButtonIcon('resendMfa','mfaLoginForm') }}</mat-icon>
                      </span>
                    </button>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="activeForm !== 'mfaLoginForm'">
                <ng-container *ngFor="let btn of signUpData.forms[activeForm].buttons; let bi = index">
                  <button type="button"
                    *ngIf="!(btn.action === 'goBack' && activeForm === 'signupForm' && currentStep === 0)"
                    (click)="onButtonClick(btn)" [class]="btn.class"
                    [disabled]="isSubmitting && btn.class === 'submit-btn'">
                    <span class="button-content" [class.reverse-order]="btn.class === 'submit-btn'">
                      <mat-icon *ngIf="btn.icon && btn.class !== 'submit-btn'">{{ btn.icon
                        }}</mat-icon>
                      <span class="button-text">{{ btn.text }}</span>
                      <mat-icon *ngIf="btn.icon && btn.class === 'submit-btn'">{{ btn.icon
                        }}</mat-icon>
                    </span>
                  </button>
                </ng-container>
              </ng-container>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

</div>
<div class="content" id="otb-layout" *ngIf="!showContent && !showloading">
  <app-data-unavailable></app-data-unavailable>
</div>
<div class="content" id="otb-layout" *ngIf="showloading">
  <app-loader></app-loader>
</div>
<app-footer></app-footer>